import { EmploymentType } from 'src/api/zrm';

const isEmploymentNameRequired = (employmentType: EmploymentType) =>
  ![
    EmploymentType.Retired, EmploymentType.EarlyRetired, EmploymentType.Disabled, EmploymentType.NorwegianSickLeave,
  ].includes(employmentType);

export default isEmploymentNameRequired;
